import {
  base_colorContentBorder,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium } from 'ext-ui/style/typography'
import { css } from 'styled-components'

export default css`
  .BaseFlyout-Body {
    display: flex;
    min-height: 0;
    padding: 0;
  }

  .payment-detail-layout {
    display: flex;
    flex: 1;
    min-height: 0;
    flex-direction: column;
  }

  .payment-detail-header,
  .payment-detail-tabs,
  .payment-detail-scroll,
  .payment-detail-footer {
    padding-right: ${spacing(6)};
    padding-left: ${spacing(6)};
  }

  .payment-detail-header {
    padding-bottom: ${spacing(5)};

    h2 {
      margin: 0 0 ${spacing(2)};
      color: ${text_colorTextPrimary};
      font-size: 24px;
      font-family: ${font_family_weight_medium};
    }

    p {
      margin: 0;
      color: ${text_colorTextSecondary};
    }
  }

  .payment-detail-subtitle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: ${spacing(2)};
    color: ${text_colorTextSecondary};
  }

  .payment-detail-alert {
    padding: 0 ${spacing(6)} ${spacing(4)};

    .AlertPanel .subtitle {
      display: flex;
      flex-direction: column;
      gap: ${spacing(1)};
    }
  }

  .payment-detail-tabs {
    display: flex;
    gap: ${spacing(6)};
    border-bottom: 1px solid ${base_colorContentBorder};

    button {
      padding: 0 0 ${spacing(3)};
      border: 0;
      border-bottom: 2px solid transparent;
      background: transparent;
      color: ${text_colorTextSecondary};
      cursor: pointer;
    }

    button[aria-selected='true'] {
      border-bottom-color: var(--color-cta);
      color: var(--color-cta);
    }
  }

  .payment-detail-scroll {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    flex-direction: column;

    section {
      padding: ${spacing(6)} 0;
    }
    section + section {
      border-top: 1px solid ${base_colorContentBorder};
    }
    h3 {
      margin: 0 0 ${spacing(5)};
      font-size: 20px;
      color: ${text_colorTextPrimary};
    }
    p {
      margin: 0;
      white-space: pre-wrap;
      color: ${text_colorTextPrimary};
    }
  }

  dl {
    margin: 0;
  }
  dl > div {
    display: flex;
    justify-content: space-between;
    gap: ${spacing(5)};
    padding: ${spacing(2)} 0;
  }
  dt {
    color: ${text_colorTextSecondary};
  }
  dd {
    margin: 0;
    text-align: right;
    color: ${text_colorTextPrimary};
  }

  .payment-detail-link {
    padding: 0;
    border: 0;
    background: transparent;
    color: var(--color-cta);
    text-decoration: underline;
    cursor: pointer;
  }

  .payment-activity-list {
    display: flex;
    margin: 0;
    padding: 0;
    list-style: none;
    flex-direction: column;
    gap: ${spacing(5)};
  }
  .payment-activity-list li {
    position: relative;
    display: grid;
    grid-template-columns: 20px 1fr auto;
    gap: ${spacing(1)} ${spacing(3)};
  }
  .payment-activity-list li::after {
    position: absolute;
    top: 18px;
    bottom: -${spacing(5)};
    left: 7px;
    width: 1px;
    content: '';
    background: ${base_colorContentBorder};
  }
  .payment-activity-list li:last-child::after {
    display: none;
  }
  .payment-activity-list strong {
    grid-column: 2;
  }
  .payment-activity-list span {
    color: ${text_colorTextSecondary};
  }
  .payment-activity-list strong + span {
    grid-column: 2;
  }
  .payment-activity-list time {
    grid-column: 3;
    grid-row: 1 / span 2;
    color: ${text_colorTextSecondary};
  }
  .payment-activity-list .payment-activity-marker {
    z-index: 1;
    grid-column: 1;
    grid-row: 1 / span 2;
    width: 15px;
    height: 15px;
    margin-top: 2px;
    border: 3px solid var(--color-cta);
    border-radius: 50%;
    background: white;
  }

  .payment-detail-footer {
    display: flex;
    justify-content: flex-end;
    gap: ${spacing(3)};
    padding-top: ${spacing(4)};
    padding-bottom: ${spacing(4)};
    border-top: 1px solid ${base_colorContentBorder};
  }

  .payment-detail-message {
    display: flex;
    margin: auto;
    padding: ${spacing(8)};
    align-items: center;
    flex-direction: column;
    gap: ${spacing(4)};
    color: ${text_colorTextSecondary};
  }
  .payment-detail-message p {
    margin: 0;
  }
`
